import { validatePlatformContent } from "utils/newMediaValidation";

/**
 * Validates Meta Threads post content and media
 * @param {Object} params - The parameters for validation
 * @param {Array} params.thread - The thread content array
 * @param {Object} params.platformMedia - Media objects for all platforms
 * @param {Number} params.monthlyPosts - Available monthly posts
 * @returns {Object} - Validation results with errors and loading status
 */
const validateMetaThreads = ({
  thread,
  platformMedia,
  monthlyPosts,
}) => {
  const errorList = [];
  const newMediaLoadingList = [];

  thread?.forEach((item, idx) => {
    const post = item?.content;
    const mediaList = platformMedia?.meta_threads?.[idx] ?? [];

    const { platformErrors, mediaList: mediaListValidated } =
      validatePlatformContent({
        mediaListRaw: mediaList,
        platform: "meta_threads",
        caption: post,
      });

    errorList.push(
      platformErrors.length > 0 ||
        mediaListValidated.some((media) => media.errors.length > 0)
    );

    if (mediaList?.length) {
      mediaList?.forEach((item) => newMediaLoadingList.push(!!item?.path));
    }

    errorList.push(monthlyPosts < 1);
  });

  return {
    hasError: errorList.includes(true),
    mediaLoadingList: newMediaLoadingList,
  };
};

export default validateMetaThreads;
